import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { unsavedDraftGuard } from '@mtm/conversation-ui-angular';

import { CampaignDriveComponent } from './campaign-drive/campaign-drive.component';
import { IndexComponent } from './index/index.component';
import { ProjectsComponent } from './projects/projects.component';
import { TimelineSimulatorComponent } from './timeline-generator/timeline-simulator/timeline-simulator.component';
import { WorkspaceDashboardComponent } from './workspace-dashboard/workspace-dashboard.component';
import { CanAccessTimelineSimulator } from '../shared/guards/timeline-simulator.guard';
import { CanAccessWorkspace } from '../shared/guards/can-access-workspace';
import { CanAccessCampaign } from '../shared/guards/can-access-campaign';
import { canAccessWorkspaceTask } from '../shared/guards/can-access-workspace-task';
import { canAccessCampaignTask } from '../shared/guards/can-access-campaign-task';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    canDeactivate: [unsavedDraftGuard],
    children: [
      {
        path: '',
        canActivate: [CanAccessWorkspace], // Apply guard for agency users
        component: WorkspaceDashboardComponent,
        canDeactivate: [unsavedDraftGuard],
      },
      {
        path: 'campaign-drive',
        canActivate: [CanAccessCampaign], // Apply guard for agency users
        component: CampaignDriveComponent,
        canDeactivate: [unsavedDraftGuard],
      },
      {
        path: 'projects',
        component: ProjectsComponent,
        canDeactivate: [unsavedDraftGuard],
      },
      {
        path: 'timeline-simulator',
        canActivate: [CanAccessTimelineSimulator],
        component: TimelineSimulatorComponent,
        canDeactivate: [unsavedDraftGuard],
      },
      {
        path: 'campaigndrive',
        loadChildren: () =>
          import('./timeline-generator/timeline-generator.module').then((m) => m.TimelineGeneratorModule),
      },
      {
        path: 'campaigndrive/dashboard',
        loadChildren: () =>
          import('./campaign-drive-dashboard/campaign-drive-dashboard.module').then(
            (m) => m.CampaignDriveDashboardModule
          ),
      },
      {
        path: 'analytics',
        loadChildren: () => import('./analytics/analytics.module').then((m) => m.AnalyticsModule),
      },
      {
        path: 'reporting',
        loadChildren: () => import('./analytics/reporting-v2/reporting.module').then((m) => m.ReportingModule),
      },
      {
        path: 'self-trainer',
        loadChildren: () => import('./analytics/self-trainer/self-trainer.module').then((m) => m.SelfTrainerModule),
      },
      {
        path: ':workspaceId/tasks',
        canActivate: [canAccessWorkspaceTask],
        loadChildren: () => import('../sub-modules/task-v2-module/task-v2.module').then((m) => m.TaskV2Module),
      },
      {
        path: ':workspaceId/campaign-drive/:campaignId/tasks',
        canActivate: [canAccessCampaignTask],
        loadChildren: () => import('../sub-modules/task-v2-module/task-v2.module').then((m) => m.TaskV2Module),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignWorkspaceRoutingModule {}
